import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登录接口
export const login = (params) => { return loginreq("post", "/api/login/index", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu",{headers:{token:localStorage.getItem('token')}}).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login/loginout",{headers:{token:localStorage.getItem('token')}}).then(res => res.data) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/main/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 活码管理
 **/
// 活码管理-获取活码列表
export const qrList = (params) => { return req("post", "/api/main/qrlist", params) };
// 活码管理-保存（添加编辑）
export const qrSave = (params) => { return req("post", "/api/main/qrsave", params) };
// 子码管理-保存（添加编辑）
export const zmSave = (params) => { return req("post", "/api/main/zmsave", params) };
// 子码管理-批量链接保存
export const plAddlj = (params) => { return req("post", "/api/main/pladdlianjie", params) };
// 子码管理-批量口令保存
export const plAddkl = (params) => { return req("post", "/api/main/pladdkouling", params) };
// 活码管理-删除活码
export const qrDelete = (params) => { return axios.get("/api/main/qrdel?id=" + params, {headers:{token:localStorage.getItem('token')}}).then(res => res.data) };
//活码管理-编辑（修改编辑）
export const qrEdit = (params) => { return req("post", "/api/main/qredit", params) };
// 活码管理-保存（编辑提交）
export const qrSave1 = (params) => { return req("post", "/api/main/qrsave1", params) };
// 活码管理-保存（新增提交）
export const zimaList = (params) => { return req("post", "/api/main/zmlist", params) };
// 活码管理-保存子码标题
export const zmtitleSave = (params) => { return req("post", "/api/main/zmtitlesave", params) };
// 活码管理-保存子码阈值
export const zmyuzhiSave = (params) => { return req("post", "/api/main/zmyuzhisave", params) };
// 活码管理-保存子码极限值
export const zmmaxscanSave = (params) => { return req("post", "/api/main/zmmaxscansave", params) };
// 活码管理-保存子码序号
export const zmxuhaoSave = (params) => { return req("post", "/api/main/zmxuhaosave", params) };
// 活码管理-删除子码
export const zmDelsel = (params) => { return req("post", "/api/main/zmdelsel", params) };
// 活码管理-批量启用子码
export const zmQisel = (params) => { return req("post", "/api/main/zmqisel", params) };
// 活码管理-批量停用子码
export const zmTingsel = (params) => { return req("post", "/api/main/zmtingsel", params) };
// 活码管理-批量修改子码阈值
export const zmYuzhisel = (params) => { return req("post", "/api/main/zmyuzhisel", params) };
// 活码管理-统计报表获取小时段统计（今日、昨日）
export const hourTongji = (params) => { return req("post", "/api/tongji/hourtongji", params) };
// 活码管理-统计报表获取日统计（最近7天、30天）
export const dayTongji = (params) => { return req("post", "/api/tongji/daytongji", params) };
/**
 * 域名管理
 */
//域名管理-获取域名列表
export const getYuming = () => { return req("post", "/api/main/getyuming") };
//域名管理-保存域名
export const ymSave = (params) => { return req("post", "/api/main/ymsave", params) }
/**
 * 一物一码管理
 **/
// 一物一码管理-获取分类列表
export const categoryList = (params) => { return req("post", "/api/category/list", params) };
// 一物一码管理-保存分类（添加或编辑）
export const categorySave = (params) => { return req("post", "/api/category/save", params) };
// 一物一码管理-删除分类
export const categoryDelete = (params) => { return axios.delete("/api/category/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 一物一码管理-获取活码列表
export const huomaList = (params) => { return req("post", "/api/huoma/list", params) };
//一物一码管理-批量生成活码
export const huomaSave = (params) => { return req("post", "/api/huoma/save", params) }
//一物一码管理-批量导出活码
export const huomaExport = (params) => { return req("post", "/api/huoma/export", params) }
/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js